import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enUSGeneral from "./enUS/general.json";
import enUSParticipant from "./enUS/participant.json";
import enUSErrorText from "./enUS/errorText.json";
import enUSAuth from "./enUS/auth.json";
import enUSLanding from "./enUS/landing.json";

import esParticipant from "./es/participant.json";
import esErrorText from "./es/errorText.json";
import esAuth from "./es/auth.json";
import esLanding from "./es/landing.json";

import arSAParticipant from "./arSA/participant.json";
import arSAErrorText from "./arSA/errorText.json";
import arSAAuth from "./arSA/auth.json";
import arSALanding from "./arSA/landing.json";

import csParticipant from "./cs/participant.json";
import csErrorText from "./cs/errorText.json";
import csAuth from "./cs/auth.json";
import csLanding from "./cs/landing.json";

import plParticipant from "./pl/participant.json";
import plErrorText from "./pl/errorText.json";
import plAuth from "./pl/auth.json";
import plLanding from "./pl/landing.json";

import trParticipant from "./tr/participant.json";
import trErrorText from "./tr/errorText.json";
import trAuth from "./tr/auth.json";
import trLanding from "./tr/landing.json";

import deParticipant from "./de/participant.json";
import deErrorText from "./de/errorText.json";
import deAuth from "./de/auth.json";
import deLanding from "./de/landing.json";

import jaParticipant from "./ja/participant.json";
import jaErrorText from "./ja/errorText.json";
import jaAuth from "./ja/auth.json";
import jaLanding from "./ja/landing.json";

import { DEFAULT_LOCALE } from "./helpers";

export const resources = {
  "ar-SA": {
    translation: {
      ...arSAParticipant,
      ...arSAErrorText,
      ...arSAAuth,
      ...arSALanding,
    },
  },
  cs: {
    translation: {
      ...csParticipant,
      ...csErrorText,
      ...csAuth,
      ...csLanding,
    },
  },
  "en-US": {
    translation: {
      ...enUSGeneral,
      ...enUSParticipant,
      ...enUSErrorText,
      ...enUSAuth,
      ...enUSLanding,
    },
  },
  pl: {
    translation: {
      ...plParticipant,
      ...plErrorText,
      ...plAuth,
      ...plLanding,
    },
  },
  es: {
    translation: {
      ...esParticipant,
      ...esErrorText,
      ...esAuth,
      ...esLanding,
    },
  },
  tr: {
    translation: {
      ...trParticipant,
      ...trErrorText,
      ...trAuth,
      ...trLanding,
    },
  },
  de: {
    translation: {
      ...deParticipant,
      ...deErrorText,
      ...deAuth,
      ...deLanding,
    },
  },
  ja: {
    translation: {
      ...jaParticipant,
      ...jaErrorText,
      ...jaAuth,
      ...jaLanding,
    },
  },
};

// For more info about this configuration check https://react.i18next.com/latest/using-with-hooks
i18n
  // pass the i18n instance to react-i18next .
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    debug: false,
    keySeparator: false,
  });

export default i18n;
